import apiUserSupplier from '@/api/userSupplier';
import apiOption from '@/api/option';

const defaultState = () => ({
	userResults: [],
	userPagination: '',
	responSukses: {},
	alert: '',
	responseError: {},
	konfirmResponse: {},
	OptionSupplier: [],
	OptionType: []
});

const state = defaultState();

const getters = {

};

const mutations = {
	listUser(state, data) {
		state.userResults = data.data.map((el) => {
			if (el.user_supplier_is_active == "active") {
				el.user_supplier_is_active = true
			} else {
				el.user_supplier_is_active = false
			}
			return el
		});
		state.userPagination = data.pagination;
	},
	listOptionType(state, data) {
		state.OptionType = data;
	},
	listOptionSupplier(state, data) {
		state.OptionSupplier = data
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataUser(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getDataUser({ commit }, value) {
		apiUserSupplier.getDataUser(value).then(({ data: { data } }) => {
			commit('listUser', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('listUser', { data: [], pagination: {} });
		});
	},
	getTypeOption({ commit }) {
		apiOption.getOptionType().then(({ data: { data: { results } } }) => {
			commit('listOptionType', results);
		}).catch(() => {
			commit('listOptionType', []);
		});
	},
	getSupplierOption({ commit }) {
		return new Promise((resolve) => {
			apiOption.getOptionSupplier().then(({ data: { data: { results } } }) => {
				commit('listOptionSupplier', results);
				resolve(results)
			}).catch(() => {
				commit('listOptionSupplier', []);
				resolve([])
			});
		})
	},
	async exportUser({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiUserSupplier.exportUser(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data user supplier'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async add({ dispatch, commit }, value) {
		await apiUserSupplier.addUser(value).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menambah data user'
			}, { root: true });
		});
	},
	async update({ dispatch, commit }, value) {
		await apiUserSupplier.updateUser(value).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah data user'
			}, { root: true });
		});
	},
	async delete({ dispatch, commit }, value) {
		await apiUserSupplier.deleteUser({ id: value }).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus data user'
			}, { root: true });
		});
	},
	async updatePasswordSupplier({ dispatch, commit }, value) {
		await apiUserSupplier.updatePasswordSupplier(value).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah status user'
			}, { root: true });
		});
	},
	async status({ dispatch, commit }, value) {
		await apiUserSupplier.statusUser(value).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch(err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal mengubah status user'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};